import * as t from "./actions";

export interface IUserState {
  name: string;
  username: string;
  email: string;
  uid: string;
  permissions: any;
  features: any;
}

const initialUserState: IUserState = {
  name: "",
  username: "",
  email: "",
  uid: "",
  permissions: {
    access_marketplace_dashboard: {
      Merchant: []
    },
    access_marketplace_dashboard_finance: {
      Merchant: []
    }
  },
  features: ""
};

export default function (
  state = initialUserState,
  action: IPayload
): IUserState {
  switch (action.type) {
    case t.USER_LOGIN_SUCCESS:
      return {
        name: action.payload.name,
        username: action.payload.login,
        email: action.payload.email,
        uid: action.payload.uid,
        permissions: action.payload.permissions,
        features: action.payload.features
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./client/modules/User/reducer.ts